<template>
    <!-- Change this with menu entry -->
    <div
    class="menu-sub-item"
    :class="{ 'menu-collapsed': menuCollapsed, 'selected': selected, 'mobile': getMobileAppState }"
    @click="emit('clicked', submenuEntry)"><span>{{submenuEntry.name}}</span></div>
</template>

<script setup>
/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* Emmitters */
const emit = defineEmits(['clicked'])

/** props received
@submenuEntry {Object} with menu info, tho it has many info, the only one needed is:
- name {String}
@menuCollapsed {Boolean}
@selected {String}
**/
const props = defineProps({
    submenuEntry: Object,
    menuCollapsed: Boolean,
	selected: Boolean
})

const { getMobileAppState } = mapGetters()
</script>

<style lang="scss" scoped>
.menu-sub-item {
    width: 100%;
    height: 40px;
    padding-left: 32px;

    @include H7-Medium;
    line-height: 40px;
    color: var(--menu-main-text-icon-color);

    border-radius: 8px;
    cursor: pointer;

    span {
        opacity: 0.88;
    }

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background-color: rgba(var(--menu-main-bg-color-hover), var(--menu-bg-opacity-state-hover));
        }
    }

    &:active {
        background-color: rgba(var(--menu-main-bg-color-active), var(--menu-bg-opacity-state-press));
    }

    &.selected {
        background-color: var(--menu-main-bg-selected);
        color: var(--menu-main-text-icon-selected);

        span {
            opacity: 1;
        }
    }

    &.mobile {
        width: 100%;
        padding-left: 24px;

        color: var(--secondary-dark-1);

        &:active {
            background-color: var(--secondary-light-2);
        }

        &.selected {
            background-color: var(--primary);
            color: var(--secondary-light-2);
        }
    }
}
</style>
